import { createReducer } from '@reduxjs/toolkit'

import { clearSummary, receivedSummary, requestSummary } from '../actions/actions'

export const initialState = {
  loading: false,
  price: 0,
  regularPrice: 0,
  discount: 0,
  covered: 0
}

const summary = createReducer(initialState, {
  [requestSummary]: (state, { payload }) => {
    state.loading = true
    state.lastRequestPayload = payload
  },
  [receivedSummary]: (state, { payload }) => {
    state.loading = false
    state.price = payload.price
    state.regularPrice = payload.priceRegular
    state.discount = payload.priceDiscount
    state.covered = payload.priceCovered
  },
  [clearSummary]: () => initialState
})

export default summary
